import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import Input from "../../../component-lib/Atoms/Input/Input";
import Button from "../../../component-lib/Molecules/button/Button";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import SelectDropdown from "../../../component-lib/Atoms/Select/Select";

import { STATUS_FOR_TASK } from "../constant";

// ADD TASK FORM

export const EDIT_TASK_DETAILS = {
  STATUS: "status",
};

interface EditTaskProps {
  defaultSelectedData?: any;
  handleOnSubmittedData?: (formData: any) => void;
  //   handleOnSubmit: (updatedStatus: string) => void;
  handleClose: () => void;
}

export const EditTask = ({
  defaultSelectedData,
  //   handleOnSubmit,
  handleClose,
  handleOnSubmittedData,
}: EditTaskProps) => {
  const validationSchema = Yup.object().shape({
    [EDIT_TASK_DETAILS.STATUS]: Yup.string()
      .required("Status is required")
      .oneOf(
        STATUS_FOR_TASK.map((option) => option.value),
        "Invalid status"
      ),
  });
  //GET PATIENT LOGIC START:  BELOW USE EFFECT AND FUNCTIONS  WE ARE USING FOR GET PATIENT LIST, SEARCH PATIENT , AND LAZY LOAD PATIENT DATA
  return (
    <Formik
      initialValues={{
        [EDIT_TASK_DETAILS.STATUS]: `${defaultSelectedData?.status ? (defaultSelectedData?.status === "Pending" ? "pending" : defaultSelectedData?.status === "In Progress" ? "inProgress" : defaultSelectedData?.status === "Completed" ? "completed" : defaultSelectedData?.status) : ""}`,
      }}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={(values, { setSubmitting }) => {
        try {
          handleOnSubmittedData && handleOnSubmittedData(values);
          // Handle form data here
          // If needed, call an API or further process the values here
        } catch (error) {
          console.log(error);
        } finally {
          setSubmitting(false); // Reset submitting state
        }
      }}
    >
      {({ errors, touched, values, setFieldValue, handleSubmit }) => (
        <form
          onSubmit={handleSubmit}
          className="h-full flex flex-col justify-between rounded-lg"
        >
          <div className="w-full flex flex-col gap-6 rounded-lg">
            <SelectDropdown
              label="Status"
              name={EDIT_TASK_DETAILS.STATUS}
              value={values[EDIT_TASK_DETAILS.STATUS]}
              options={STATUS_FOR_TASK}
              onChangeCb={(e) =>
                setFieldValue(EDIT_TASK_DETAILS.STATUS, e.target.value)
              }
              error={Boolean(
                touched[EDIT_TASK_DETAILS.STATUS] &&
                  errors[EDIT_TASK_DETAILS.STATUS]
              )}
              helperText={
                touched[EDIT_TASK_DETAILS.STATUS]
                  ? errors[EDIT_TASK_DETAILS.STATUS]
                  : undefined
              }
            />
          </div>

          <div className="flex justify-end mt-6 gap-4">
            <Button
              label={TEXT_CONSTANTS?.CANCEL}
              variant="outlined"
              onClickCb={() => {
                if (handleClose) {
                  handleClose(); // Call the handleClose function if it's defined
                }
              }}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
                backgroundColor: "white",
                border: "none",
                color: "#393939",
              }}
            />
            <Button
              // disabled={!isValid} // Button disabled if form is invalid or submitting
              type="submit"
              label={TEXT_CONSTANTS?.SAVE}
              variant="contained"
              onClickCb={() => {}}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
              }}
            ></Button>
          </div>
        </form>
      )}
    </Formik>
  );
};

// ADD TASK DIALOG

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "436px",
    width: "708px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface EditTaskDialogProps {
  isOpen: boolean;
  dialogHeading: string;
  defaultTaskData?: any;
  handleClose: () => void;
  handleEditTaskData: (data: any) => void;
}

export default function EditTaskDialog({
  isOpen = false,
  defaultTaskData,
  handleClose,
  handleEditTaskData = () => {},
  dialogHeading = "Your Heading Here...",
}: EditTaskDialogProps) {
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers>
          <EditTask
            defaultSelectedData={defaultTaskData}
            handleOnSubmittedData={(formData) => {
              handleEditTaskData(formData);
            }}
            handleClose={handleClose}
          />
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
